/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetStaffelsQueryVariables = Types.Exact<{
  search: Types.StaffelSearch;
  pagination: Types.Pagination;
}>;


export type GetStaffelsQuery = {
  __typename?: 'Query',
  staffels: {
    __typename?: 'StaffelPage',
    totalElements: number,
    content: Array<{
      __typename: 'FeetStaffel',
      id: number,
      description?: string | null,
      discriminator: string,
      staffelItems?: Array<{
        __typename: 'FeetStaffelItem',
        price?: number | null,
        startFeet?: number | null,
        endFeet?: number | null,
        reefer?: boolean | null,
        empty?: boolean | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'GasolineStaffelItem',
        surcharge?: number | null,
        startPrice?: number | null,
        endPrice?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'WaterLevelStaffelItem',
        surcharge?: number | null,
        startWaterLevelCm?: number | null,
        endWaterLevelCm?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      }> | null
    } | {
      __typename: 'GasolineStaffel',
      id: number,
      description?: string | null,
      discriminator: string,
      staffelItems?: Array<{
        __typename: 'FeetStaffelItem',
        price?: number | null,
        startFeet?: number | null,
        endFeet?: number | null,
        reefer?: boolean | null,
        empty?: boolean | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'GasolineStaffelItem',
        surcharge?: number | null,
        startPrice?: number | null,
        endPrice?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'WaterLevelStaffelItem',
        surcharge?: number | null,
        startWaterLevelCm?: number | null,
        endWaterLevelCm?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      }> | null
    } | {
      __typename: 'WaterLevelStaffel',
      waterlevelMeasuringPoint?: number | null,
      id: number,
      description?: string | null,
      discriminator: string,
      staffelItems?: Array<{
        __typename: 'FeetStaffelItem',
        price?: number | null,
        startFeet?: number | null,
        endFeet?: number | null,
        reefer?: boolean | null,
        empty?: boolean | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'GasolineStaffelItem',
        surcharge?: number | null,
        startPrice?: number | null,
        endPrice?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      } | {
        __typename: 'WaterLevelStaffelItem',
        surcharge?: number | null,
        startWaterLevelCm?: number | null,
        endWaterLevelCm?: number | null,
        id: number,
        discriminator: string,
        staffel: {
          __typename?: 'FeetStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'GasolineStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        } | {
          __typename?: 'WaterLevelStaffel',
          id: number,
          description?: string | null,
          discriminator: string
        }
      }> | null
    }>
  }
};

export type GetAllStaffelsQueryVariables = Types.Exact<{
  search: Types.StaffelSearch;
}>;


export type GetAllStaffelsQuery = {
  __typename?: 'Query',
  allStaffels?: Array<{
    __typename: 'FeetStaffel',
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  } | {
    __typename: 'GasolineStaffel',
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  } | {
    __typename: 'WaterLevelStaffel',
    waterlevelMeasuringPoint?: number | null,
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  }> | null
};

export type GetStaffelQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetStaffelQuery = {
  __typename?: 'Query',
  staffel?: {
    __typename: 'FeetStaffel',
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  } | {
    __typename: 'GasolineStaffel',
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  } | {
    __typename: 'WaterLevelStaffel',
    waterlevelMeasuringPoint?: number | null,
    id: number,
    description?: string | null,
    discriminator: string,
    staffelItems?: Array<{
      __typename: 'FeetStaffelItem',
      price?: number | null,
      startFeet?: number | null,
      endFeet?: number | null,
      reefer?: boolean | null,
      empty?: boolean | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'GasolineStaffelItem',
      surcharge?: number | null,
      startPrice?: number | null,
      endPrice?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    } | {
      __typename: 'WaterLevelStaffelItem',
      surcharge?: number | null,
      startWaterLevelCm?: number | null,
      endWaterLevelCm?: number | null,
      id: number,
      discriminator: string,
      staffel: {
        __typename?: 'FeetStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'GasolineStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      } | {
        __typename?: 'WaterLevelStaffel',
        id: number,
        description?: string | null,
        discriminator: string
      }
    }> | null
  } | null
};


export const GetStaffelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStaffels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffelSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Staffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffelItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffelItem"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waterlevelMeasuringPoint"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffelItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurchargeStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surcharge"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeetStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFeet"}},{"kind":"Field","name":{"kind":"Name","value":"endFeet"}},{"kind":"Field","name":{"kind":"Name","value":"reefer"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GasolineStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPrice"}},{"kind":"Field","name":{"kind":"Name","value":"endPrice"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startWaterLevelCm"}},{"kind":"Field","name":{"kind":"Name","value":"endWaterLevelCm"}}]}}]}}]} as unknown as DocumentNode<GetStaffelsQuery, GetStaffelsQueryVariables>;
export const GetAllStaffelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllStaffels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffelSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allStaffels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Staffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffelItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffelItem"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waterlevelMeasuringPoint"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffelItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurchargeStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surcharge"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeetStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFeet"}},{"kind":"Field","name":{"kind":"Name","value":"endFeet"}},{"kind":"Field","name":{"kind":"Name","value":"reefer"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GasolineStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPrice"}},{"kind":"Field","name":{"kind":"Name","value":"endPrice"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startWaterLevelCm"}},{"kind":"Field","name":{"kind":"Name","value":"endWaterLevelCm"}}]}}]}}]} as unknown as DocumentNode<GetAllStaffelsQuery, GetAllStaffelsQueryVariables>;
export const GetStaffelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStaffel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Staffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffelItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralStaffelItem"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waterlevelMeasuringPoint"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralStaffelItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}},{"kind":"Field","name":{"kind":"Name","value":"staffel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discriminator"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PriceStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurchargeStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surcharge"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeetStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFeet"}},{"kind":"Field","name":{"kind":"Name","value":"endFeet"}},{"kind":"Field","name":{"kind":"Name","value":"reefer"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GasolineStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPrice"}},{"kind":"Field","name":{"kind":"Name","value":"endPrice"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaterLevelStaffelItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startWaterLevelCm"}},{"kind":"Field","name":{"kind":"Name","value":"endWaterLevelCm"}}]}}]}}]} as unknown as DocumentNode<GetStaffelQuery, GetStaffelQueryVariables>;